import { createAsyncThunk } from "@reduxjs/toolkit";

import { getErrorMessage } from "@fitness-app/utils";

import { type AsyncThunkCreator } from "../../../index";
import { MEDIA_LIBRARY_REDUCER_NAME } from "../types";

type Payload = {
  id: string;
  path: string;
  bucketName: string;
  name: string;
};

interface Response {
  status: string;
  url: string;
  path: string;
}

export const convertFileToMp3 = createAsyncThunk<Response, Payload, AsyncThunkCreator<string>>(
  `${MEDIA_LIBRARY_REDUCER_NAME}/convertFileToMp3`,
  async (payload, { rejectWithValue, extra: { mediaLibraryApi, analytics } }) => {
    try {
      const response = await mediaLibraryApi.post<Response>("/convert-to-mp3", payload);
      analytics.track("add_new_audio_file");
      return response.data;
    } catch (e) {
      return rejectWithValue(getErrorMessage(e));
    }
  },
);
